import React from 'react';
import { FloatingMenu as FloatingMenuBase } from '../../../../CommonComponents/OPL/FloatingMenu/FloatingMenu';
import { FmToggleButton } from '../../../../CommonComponents/OPL/FloatingMenu/components/FmToggleButton/FmToggleButton';
import { FmMenuButton } from '../../../../CommonComponents/OPL/FloatingMenu/components/FmMenuButton/FmMenuButton';
import { MenuContent, MenuHeader, MenuItem } from '../../../../CommonComponents/OPL/Menu/Menu';
import { ListItem } from '../../../../CommonComponents/OPL/List/ListItem';
import { FmButton } from '../../../../CommonComponents/OPL/FloatingMenu/components/FmButton/FmButton';
import { ComparisonResultDTO, ComparisonDTO } from '../../../api/useSurveyResultsQuery';
import { useIsMobile } from '../../../../_hooks/useIsMobile';
import { useClientId } from '../../../../_hooks/useClientId';

interface Props {
  isComparing: boolean;
  setIsComparing: (isComparing: boolean) => void;
  comparisons: ComparisonDTO[];
  comparisonResult: ComparisonResultDTO;
  isFromSurvey?: boolean;
  compareToId?: string;
  onShareClick?: () => void;
}

export const FloatingMenu = ({
  isFromSurvey,
  isComparing,
  compareToId,
  setIsComparing,
  comparisons,
  comparisonResult,
  onShareClick,
}: Props) => {
  const isMobile = useIsMobile();
  const clientId = useClientId();

  return (
    <FloatingMenuBase position="sticky" animationDelay={isFromSurvey ? 1.5 : 0}>
      <FmToggleButton
        isPressed={!isComparing}
        onClick={() => setIsComparing(false)}
        css="flex-shrink: 0"
      >
        You
      </FmToggleButton>

      {comparisons.length === 1 ? (
        <FmToggleButton isPressed={isComparing} onClick={() => setIsComparing(true)}>
          You &amp; {comparisonResult.partnerName}
        </FmToggleButton>
      ) : (
        <FmMenuButton
          buttonText={`You & ${comparisonResult.partnerName}`}
          menuAriaLabel="Select Comparison"
          isPressed={isComparing}
          onClick={() => setIsComparing(true)}
        >
          <MenuContent align="end">
            <MenuHeader>Select Comparison</MenuHeader>

            {comparisons.map(comparison => (
              <MenuItem
                key={comparison.id}
                onSelect={() => {
                  setIsComparing(true);
                  ADV.util.Router.go2('BeFi20Results', {
                    clientId,
                    compareToId: comparison.id,
                    isInitiallyComparing: true,
                  });
                }}
                css={`
                  padding-left: ${compareToId !== comparison.id ? '45px' : '16px'};
                `}
              >
                <ListItem
                  icon={compareToId === comparison.id ? 'far fa-check' : undefined}
                  variant={compareToId === comparison.id ? 'selected' : undefined}
                  subText={`${comparison.similarity} similarity`}
                >
                  {comparison.name}
                </ListItem>
              </MenuItem>
            ))}
          </MenuContent>
        </FmMenuButton>
      )}

      {!isMobile && <FmButton onClick={onShareClick}>Share &amp; Compare</FmButton>}
    </FloatingMenuBase>
  );
};
